/* eslint-disable */

export const getAllCoinsConstants = {
    GET_COINS_REQUEST: 'GET_COINS_REQUEST',
    GET_COINS_SUCCESS: 'GET_COINS_SUCCESS',
    GET_COINS_FAILURE: 'GET_COINS_FAILURE',
};
